import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageDialog } from '../../../components/message-dialog/messageDialog';
import { ListFormBase } from '../../../core/helper/ListFormBase';
import { SessionHelper } from '../../../core/helper/sessionHelper';
import { A3LCompany } from '../../../core/models/a3LCompany.model';
import { PeriodosBolsaVacacionesModel } from '../../../core/models/periodosBolsaVacaciones.model';
import { Sustitucion } from '../../../core/models/sustitucion.model';
import { SustitucionService } from '../../../core/services/sustitucion.service';


@Component({
  selector: 'app-gestion-susticiones-baja',
  templateUrl: './gestion-susticiones-baja-list.component.html',
  styleUrls: ['./gestion-susticiones-baja-list.component.scss'],
  providers: [SustitucionService]
})
export class GestionSusticionesBajaListComponent extends ListFormBase<Sustitucion> implements OnInit {

  panelIcon = 'people-arrows'; // material icon
  panelTitle = 'Sustituciones';
  panelDescription = '';

  sustituciones: Sustitucion[] = new Array<Sustitucion>();
  periodos: PeriodosBolsaVacacionesModel[] = new Array<PeriodosBolsaVacacionesModel>();

  companies: A3LCompany[] = new Array<A3LCompany>();
  selectedCompany: number;
  selectedYear: number;
  esEditable: true;
  isValid: boolean = true;
  sustitucionesCerradas: boolean = false;

  constructor(
    protected _modelService: SustitucionService,
    protected _router: Router,
    _route: ActivatedRoute,
    private _sessionHelper: SessionHelper,
    protected _messageDialog: MessageDialog) {

    super(_modelService, _router, _route, _messageDialog, Sustitucion);
    this.isCrud = true;
    this.selectedCompany = this._sessionHelper.LastCompanySelectedBolsaVacaciones;
  }

  ngOnInit() {
    setTimeout(() => {
      if (this.selectedCompany) {
        this.onSearch();
      }
    }, 60);
  }

  getDataSource() {
    this._modelService.getAllModelsByCompany(this.selectedCompany, this.selectedYear, this.sustitucionesCerradas).subscribe((response: Sustitucion[]) => {
      if (response) {
        this.dataSource = response ?? new Array<Sustitucion>();
      }
      this.dataGrid.instance.endCustomLoading();
    }, error => {
      console.error(error);
      this._messageDialog.ShowException(error);
      this.dataGrid.instance.endCustomLoading();
    });
  }

  onSearch() {
    this.dataGrid.instance.beginCustomLoading('');
    this._sessionHelper.LastCompanySelectedBolsaVacaciones = this.selectedCompany;
    this.getDataSource();
  }

  getSustitutoCalculateDisplayValue(data: Sustitucion) {
    console.log(data);
    if(data.EmpleadoSustituto?.A3LCompleteName) {
      return data.EmpleadoSustituto?.A3LCompleteName;
    }

    return "Sin sustituto";

  }

}

